import * as THREE from "three";
// Live camera snapshot for bookmarks (updated each frame by Scene).
export const cameraState = {
  position: [180, 150, 260],
  target: [-10, 60, -20],
};
const _fwd = new THREE.Vector3();
export function updateCameraState(camera) {
  cameraState.position = [
    +camera.position.x.toFixed(1),
    +camera.position.y.toFixed(1),
    +camera.position.z.toFixed(1),
  ];
  camera.getWorldDirection(_fwd);
  cameraState.target = [
    +(camera.position.x + _fwd.x * 120).toFixed(1),
    +(camera.position.y + _fwd.y * 120).toFixed(1),
    +(camera.position.z + _fwd.z * 120).toFixed(1),
  ];
}
